export var MapQueryOperator;
(function (MapQueryOperator) {
    MapQueryOperator["LessThan"] = "<";
    MapQueryOperator["GreaterThan"] = ">";
    MapQueryOperator["EqualsTo"] = "=";
    MapQueryOperator["NotEquals"] = "<>";
    MapQueryOperator["Like"] = "LIKE";
})(MapQueryOperator || (MapQueryOperator = {}));
